module.exports = "/_next/static/images/bg-red-bar-98b3e814.png";